import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

import AllInOneBanner from '../../../assets/images/all-in-one-element.png';
import AppleStoreIcon from '../../../assets/images/apple-store.svg';
import PlayStoreIcon from '../../../assets/images/play-store-icon.svg';

const AllInOne = () => {
  return (
    <section className="bg bg--dark mfone-all-in-one">
      <div className="container">
        <div>
          <Image
            style={{ color: undefined }}
            src={AllInOneBanner}
            alt="all in one"
            height={400}
            className="web-view"
          />
          <Image
            style={{ color: undefined }}
            src={AllInOneBanner}
            alt="all in one"
            height={300}
            className="mobile-view"
          />
        </div>
        <div>
          <h1 className="section__title text--white section-title">
            <p>The All-In-One</p>
            <p>Financial App</p>
          </h1>
          <p className="section__desc section-desc">
            You can get Gold Loans, buy eSwarna Digital Gold, and trade in Forex
            with the Muthoot FinCorp ONE app whenever and wherever you want. You
            can expect more updates, more services, and more of what Muthoot
            FinCorp does best: make life easy for you.
          </p>
          <Link
            target="_blank"
            href="https://qrco.de/mfone"
            className="section__title-small text--white download-cta mt-4"
            id="all-in-one_download"
          >
            <p>Download The App</p>
            <div className="play-store-icons-container">
              <Image
                style={{ color: undefined }}
                src={AppleStoreIcon}
                alt="Play store"
                height={50}
                className="web-view"
              />
              <Image
                style={{ color: undefined }}
                src={AppleStoreIcon}
                alt="Play store"
                height={30}
                className="mobile-view"
              />
              <Image
                style={{ color: undefined }}
                src={PlayStoreIcon}
                alt="Play store"
                height={50}
                className="web-view"
              />
              <Image
                style={{ color: undefined }}
                src={PlayStoreIcon}
                alt="Play store"
                height={30}
                className="mobile-view"
              />
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default AllInOne;
